var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgHotLine = function SvgHotLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 25,
    fill: "#4CAF50"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.955 34.495a3.818 3.818 0 01-.375 1.635 6.19 6.19 0 01-1.02 1.53 6.76 6.76 0 01-2.46 1.77 7.532 7.532 0 01-2.925.57 12.5 12.5 0 01-4.89-1.095 26.346 26.346 0 01-5.16-2.97 43.13 43.13 0 01-4.92-4.2 42.634 42.634 0 01-4.185-4.905 26.738 26.738 0 01-2.94-5.115A12.632 12.632 0 0110 16.81a7.758 7.758 0 01.54-2.895 6.9 6.9 0 011.725-2.505 4.395 4.395 0 013.12-1.41c.42-.002.835.09 1.215.27.405.183.753.474 1.005.84l3.48 4.905c.24.325.442.678.6 1.05.13.288.202.599.21.915a2.036 2.036 0 01-.315 1.065 5.1 5.1 0 01-.84 1.065l-1.14 1.185a.803.803 0 00-.24.6c0 .116.015.232.045.345.045.12.09.21.12.3.403.683.87 1.326 1.395 1.92.675.78 1.395 1.575 2.175 2.37.81.795 1.59 1.53 2.385 2.205a11.51 11.51 0 001.935 1.38c.075.03.165.075.27.12.12.043.247.063.375.06a.826.826 0 00.615-.255l1.14-1.125c.316-.332.68-.616 1.08-.84a1.999 1.999 0 011.065-.315 2.4 2.4 0 01.915.195c.37.158.721.354 1.05.585l4.965 3.525c.36.235.646.568.825.96.156.37.237.768.24 1.17z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.75 20.5a5.948 5.948 0 00-1.755-3.405A5.123 5.123 0 0029.5 15.25M40 20.5A10.5 10.5 0 0029.5 10",
    stroke: "#fff",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default __webpack_public_path__ + "static/media/HotLine.e3a8292f.svg";
export { SvgHotLine as ReactComponent };